import { useCallback, useEffect, useId, useRef, useState } from "react";
import {
  Container,
  SearchBarSection,
  SearchBarSectionSubcontainer,
  SummarySection,
} from "./styles";
import SearchBar from "../../../components/ui-v2/Inputs/Search";
import { useTypedSelector } from "../../../hooks/useTypedSelector";
import DropdownFilter from "../../../components/ui-v2/DropdownFilter";
import {
  /* Table , */
  TCellStyleVariants,
  TTableBody,
} from "../../../components/ui-v2/TableGrid";

import {
  TInvoiceEntryStatus,
  setIsLoadingIssuedInvoices,
  setIsRestoringQuerystring,
  setToastState,
} from "../../../redux/reducers/globalState";
import { useTypedDispatch } from "../../../hooks/useTypedDispatch";
import {
  createIssuedInvoiceExport,
  duplicateIssuedInvoiceExport,
  fetchExportedIssuedInvoices,
  retryIssuedInvoiceExport,
} from "../../../redux/actions";
import { useNavigationManager } from "../../../hooks/useNavigationManager";
import { sub } from "date-fns/sub";
import { format } from "date-fns/format";
import { parse } from "date-fns/parse";
import { TQuerystringParams } from "../../../utils/miscellaneous";
import TableGrid from "../../../components/ui-v2/TableGrid";
import { ROUTES } from "../../../router";
import axios, { CancelTokenSource } from "axios";
import Button from "../../../components/ui-v2/Button";
import { useProportionalGridTemplateColumns } from "../../../hooks/useProportionalGridTemplateColumns";
import {
  TIssuedExportedInvoice,
  TIssuedInvoicesExport,
  TExportStatus,
} from "./mock";
import Tag from "../../../components/ui-v2/Tag";
import BreadCrumbs from "../../../components/ui-v2/BreadCrumbs";
import { differenceInDays } from "date-fns";
import Tooltip from "../../../components/ui-v2/Tooltip";
import Modal from "../../../components/ui-v2/Modal";

function IssuedInvoicesExport() {
  const dispatch = useTypedDispatch();
  const { goTo, setQuerystring } = useNavigationManager();

  const [shouldOpenExportIssuedModal, setShouldOpenExportIssuedModal] =
    useState(false);

  const payableModalInvoiceRef = useRef<TIssuedExportedInvoice | undefined>();

  // Guarda os valores atuais do formulário da modal de criação de exportação.
  const exportFormRef = useRef<
    {
      start_date?: string;
      end_date?: string;
      status_operator?: number;
      filter_status?: number[];
      nature_operator?: number;
      filter_nature?: number[];
      export_files?: string[];
    }
  >();

  const fetchInvoicesCancelTokenRef = useRef<CancelTokenSource>(
    axios.CancelToken.source()
  );

  const debounceRef = useRef<NodeJS.Timeout | null>(null);

  const { exportedIssuedInvoiceState: invoiceState } = useTypedSelector(
    (state) => state.globalState.data
  );

  const isRestoringQuerystring = useTypedSelector(
    (state) => state.globalState.isRestoringQuerystring
  );

  const isLoading = useTypedSelector(
    (state) => state.globalState.isLoadingExportedIssuedInvoices
  );

  const sidebarState = useTypedSelector((state) => state.sidebar);

  const reduxQuerystring = useTypedSelector((state) => state.querystring);

  const selectedOrganization = useTypedSelector(
    (state) => state.organizations.selectedOrganization
  );

  const startDateRef = useRef<string | undefined>(
    format(sub(new Date(), { days: 30 }), "yyyy-MM-dd")
  );
  const endDateRef = useRef<string | undefined>(
    format(new Date(), "yyyy-MM-dd")
  );

  const entryStatusRef = useRef<TInvoiceEntryStatus | undefined>(
    reduxQuerystring.launch_status === 40
      ? undefined
      : (reduxQuerystring.launch_status as TInvoiceEntryStatus)
  );

  const payablesRef = useRef<boolean | undefined>();
  const goodsEntryRef = useRef<boolean | undefined>();
  const pageRef = useRef(1);
  const itemsPerPageRef = useRef(100);
  const searchRef = useRef<string | undefined>();

  const entryStatusFilterRef = useRef<string[]>([]);
  // Ref to hold setSelected for use in onCancel
  const entryStatusSetSelectedRef = useRef<React.Dispatch<
    React.SetStateAction<string[]>
  > | null>(null);

  const allInvoicesRef = useRef<TIssuedInvoicesExport[]>([]);

  const searchBarContainerId = useId();

  const [entryStatusSearch, setEntryStatusSearch] = useState("");

  const [shouldUpdateComponent, _setShouldUpdateComponent] = useState(false);

  const [shouldRejectFilledEntryStatus /* setShouldRejectFilledEntryStatus */] =
    useState(false);

  const invoiceStatusOptions = [
    "Em processamento",
    "Autorizada",
    "Autorizada em contingência",
    "Rejeitada",
    "Denegada",
    "Cancelada",
    "Inutilizada",
  ];

  // For filtering with search:
  const filteredInvoiceStatusOptions = invoiceStatusOptions.filter((option) =>
    option.toLowerCase().includes(entryStatusSearch.toLowerCase())
  );

  const originalWidths = [0, 42, 122, 367, 427, 273, 44, 0];
  const sidebarOffset = sidebarState.isFixed ? 240 : 48;

  const gridTemplateColumns = useProportionalGridTemplateColumns(
    originalWidths,
    1440
  );

  const handleFormatStatusCell = (status: TExportStatus | null) => {
    switch (status) {
      case "Em processamento":
        return <Tag icon="noIcon" color="orange" size="medium" text={status} />;
      case "Erro ao processar":
        return <Tag color="red" icon="noIcon" size="medium" text={status} />;

      case "Finalizada":
        return <Tag color="green" icon="noIcon" size="medium" text={status} />;
      case null:
        return { style: "default", value: " - " };
    }
  };

  const handleActionButtonCell = (
    status: TExportStatus | null,
    invoice: TIssuedInvoicesExport
  ) => {
    switch (status) {
      case "Em processamento":
        return (
          <Tooltip
            text={[
              {
                text: "Exportação em",
                style: "default",
                shouldBreakLine: true,
              },
              {
                text: "andamento",
                style: "default",
                shouldBreakLine: false,
              },
            ]}
          >
            <Button
              icon="onlyIcon"
              iconType="import"
              variant="secondary"
              disabled
            />
          </Tooltip>
        );
      case "Erro ao processar":
        return (
          <Tooltip
            text={[
              { text: "Tentar", style: "default", shouldBreakLine: true },
              { text: "novamente", style: "default", shouldBreakLine: false },
            ]}
          >
            <Button
              icon="onlyIcon"
              iconType="sync"
              variant="secondary"
              onClick={() => handleRetryExport(invoice)}
            />
          </Tooltip>
        );

      case "Finalizada":
        return (
          <Tooltip
            text={[
              { text: "Baixar", style: "default", shouldBreakLine: false },
            ]}
          >
            <Button
              icon="onlyIcon"
              iconType="import"
              variant="secondary"
              onClick={() => handleDownloadExportZip(invoice)}
            />
          </Tooltip>
        );
      default:
        return (
          <Tooltip
            text={[
              { text: "Importar", style: "default", shouldBreakLine: false },
            ]}
          >
            <Button
              icon="onlyIcon"
              iconType="import"
              variant="secondary"
              disabled
            />
          </Tooltip>
        );
    }
  };

  const refreshExports = () => {
    if (fetchInvoicesCancelTokenRef.current) {
      fetchInvoicesCancelTokenRef.current.cancel(
        "Operation canceled due to new request."
      );
    }
    fetchInvoicesCancelTokenRef.current = axios.CancelToken.source();
    dispatch(
      fetchExportedIssuedInvoices({
        cancelToken: fetchInvoicesCancelTokenRef.current.token,
      })
    );
  };

  const handleDownloadExportZip = (invoice: TIssuedInvoicesExport) => {
    const url = invoice.xml_url || invoice.pdf_url;
    if (url) {
      window.open(url, "_blank");
    } else {
      dispatch(
        setToastState({
          variant: "error",
          shouldShow: true,
          message: {
            title: "Download indisponível",
            description: "O arquivo ainda não está disponível para download",
          },
        })
      );
    }
  };

  const handleRetryExport = (invoice: TIssuedInvoicesExport) => {
    const token = axios.CancelToken.source();
    dispatch(
      retryIssuedInvoiceExport({
        exportUuid: invoice.uuid,
        cancelToken: token.token,
      })
    )
      .unwrap()
      .then(() => {
        dispatch(
          setToastState({
            variant: "success",
            shouldShow: true,
            message: {
              title: "Reprocessando",
              description: "A exportação foi reenviada para processamento",
            },
          })
        );
        refreshExports();
      })
      .catch(() => {
        dispatch(
          setToastState({
            variant: "error",
            shouldShow: true,
            message: {
              title: "Erro",
              description: "Não foi possível reprocessar a exportação",
            },
          })
        );
      });
  };

  const handleDuplicateExport = (invoice: TIssuedInvoicesExport) => {
    const token = axios.CancelToken.source();
    dispatch(
      duplicateIssuedInvoiceExport({
        exportUuid: invoice.uuid,
        cancelToken: token.token,
      })
    )
      .unwrap()
      .then(() => {
        dispatch(
          setToastState({
            variant: "success",
            shouldShow: true,
            message: {
              title: "Exportação duplicada",
              description: "Uma nova exportação foi criada com os mesmos parâmetros",
            },
          })
        );
        refreshExports();
      })
      .catch(() => {
        dispatch(
          setToastState({
            variant: "error",
            shouldShow: true,
            message: {
              title: "Erro",
              description: "Não foi possível duplicar a exportação",
            },
          })
        );
      });
  };

  const handleCreateExport = () => {
    const token = axios.CancelToken.source();
    const form = exportFormRef.current ?? {};
    dispatch(createIssuedInvoiceExport({ form, cancelToken: token.token }))
      .unwrap()
      .then(() => {
        setShouldOpenExportIssuedModal(false);
        dispatch(
          setToastState({
            variant: "success",
            shouldShow: true,
            message: {
              title: "Exportação criada",
              description:
                "Aguarde enquanto o processamento e geração dos arquivos estão em andamento",
            },
          })
        );
        refreshExports();
      })
      .catch(() => {
        dispatch(
          setToastState({
            variant: "error",
            shouldShow: true,
            message: {
              title: "Erro",
              description:
                "Não foi possível criar a exportação. Verifique os campos e tente novamente",
            },
          })
        );
      });
  };

  const rowFormatter = (invoice: TIssuedInvoicesExport, _index: number) => {
    return [
      {
        style: "link",
        value: invoice?.id,
        url: {
          href:
            ROUTES.EXPORT_ISSUED_DETAILS + invoice?.id + window.location.search,
          isExternal: false,
        },
      },
      {
        style: "miscellaneous",
        values: [
          {
            style: "default",
            text: `${format(invoice.start_date, "dd/MM/yyyy")} - ${format(
              invoice.end_date,
              "dd/MM/yyyy"
            )}`,
            shouldBreakLine: true,
          },
          {
            style: "faded",
            text:
              differenceInDays(
                parse(invoice.end_date, "yyyy-MM-dd", new Date()),
                parse(invoice.start_date, "yyyy-MM-dd", new Date())
              ).toString() + " dias",
            shouldBreakLine: false,
            fontSize: "12px",
          },
        ],
      },
      {
        style: "miscellaneous",
        values: [
          {
            style: "default",
            text: `${format(invoice.start_date, "dd/MM/yyyy 'às' HH:mm")}`,
            shouldBreakLine: true,
          },
          {
            style: "default",
            text: "por " + invoice.created_by,
            shouldBreakLine: false,
          },
        ],
      },
      handleFormatStatusCell(invoice.status),
      <div style={{ display: "flex", gap: "8px" }}>
        <Tooltip
          text={[
            { text: "Duplicar", style: "default", shouldBreakLine: false },
          ]}
        >
          <Button
            icon="onlyIcon"
            iconType="copy"
            variant="secondary"
            onClick={() => handleDuplicateExport(invoice)}
          />
        </Tooltip>
        {handleActionButtonCell(invoice.status, invoice)}
      </div>,
    ] as TTableBody<TCellStyleVariants>[];
  };

  const handleEntryStatusOnAction = (
    selectDataRef: React.MutableRefObject<string[]>
  ) => {
    let hasPayable, hasGoods;
    selectDataRef.current = entryStatusFilterRef.current;

    const queryStrings = { ...reduxQuerystring };

    if (selectDataRef.current.length) {
      if (selectDataRef.current.includes("2")) {
        hasGoods = true;
      }
      if (selectDataRef.current.includes("1")) {
        hasPayable = true;
      }
      if (
        selectDataRef.current.includes("0") &&
        selectDataRef.current.length === 1
      ) {
        hasPayable = false;
        hasGoods = false;
      } else {
        hasGoods = undefined;
        hasPayable = undefined;
      }
      payablesRef.current = hasPayable;
      goodsEntryRef.current = hasGoods;

      queryStrings.has_payable_accounts = payablesRef.current;

      queryStrings.has_goods_receipt = goodsEntryRef.current;

      if (entryStatusRef.current) {
        queryStrings.launch_status = entryStatusRef.current ?? 40;
      }

      if (queryStrings.page) {
        queryStrings.page = 1;
      }

      if (queryStrings.modal) {
        delete queryStrings.modal;
      }

      setQuerystring(queryStrings);
    } else {
      payablesRef.current = undefined;
      goodsEntryRef.current = undefined;

      delete queryStrings.has_payable_accounts;
      delete queryStrings.has_goods_receipt;

      if (entryStatusRef.current) {
        queryStrings.launch_status = entryStatusRef.current ?? 40;
      }

      if (queryStrings.page) {
        queryStrings.page = 1;
      }

      if (queryStrings.modal) {
        delete queryStrings.modal;
      }

      setQuerystring(queryStrings);
    }
    debouncedUpdateAllInvoicesRef();
  };

  const handleEntryStatusOnCancel = (
    selectDataRef: React.MutableRefObject<string[]>
  ) => {
    const reset = getDefaultEntryStatusOptions(reduxQuerystring) || [];
    entryStatusFilterRef.current = reset;
    selectDataRef.current = reset;
    // Use setSelected from ref if available
    setTimeout(() => {
      if (entryStatusSetSelectedRef.current) {
        entryStatusSetSelectedRef.current(reset);
      }
    }, 200);
  };

  // Handles user selection, updates refs and state (regular multi-select, no exclusivity)
  const handleEntryStatusCustomFilter = (
    index: string,
    _selected: string[],
    setSelected: React.Dispatch<React.SetStateAction<string[]>>,
    selectDataRef: React.MutableRefObject<string[]>,
    prevSelectDataRef: React.MutableRefObject<string[]>,
    setShouldUpdate: React.Dispatch<React.SetStateAction<boolean>>
  ) => {
    // Store setSelected for use in onCancel
    entryStatusSetSelectedRef.current = setSelected;

    let currentSelection = entryStatusFilterRef.current;
    prevSelectDataRef.current = [...currentSelection];

    let newSelection: string[] = [];
    if (currentSelection.includes(index)) {
      // Deselect: remove only the clicked index
      newSelection = currentSelection.filter((v) => v !== index);
    } else {
      // Add index
      newSelection = [...currentSelection, index];
    }
    // Ensure only unique values and no empty strings
    newSelection = Array.from(new Set(newSelection)).filter((v) => v !== "");
    entryStatusFilterRef.current = newSelection;
    selectDataRef.current = newSelection;
    setSelected(newSelection);
    setShouldUpdate(true);
    setTimeout(() => setShouldUpdate(false), 20);
  };

  const getDefaultEntryStatusOptions = (queryStrings: TQuerystringParams) => {
    const hasPayableCondition = queryStrings.has_payable_accounts;
    const hasGoodsCondition = queryStrings.has_goods_receipt;
    const hasNotEntryCondition =
      hasPayableCondition === false && hasGoodsCondition === false;

    if (hasNotEntryCondition) return ["0"];
    if (hasPayableCondition && hasGoodsCondition) return ["1", "2"];
    if (hasPayableCondition) return ["1"];
    if (hasGoodsCondition) return ["2"];
    return undefined;
  };

  entryStatusFilterRef.current =
    getDefaultEntryStatusOptions(reduxQuerystring) || [];

  // Pure function for default entry status options
  const handleEntryStatusForceSelectOptions = () => {
    const result = getDefaultEntryStatusOptions({ ...reduxQuerystring });

    return result;
  };

  const updateAllInvoicesRef = useCallback(
    (_entryStatus?: number, _endDate?: string) => {
      const queryStringParams = { ...reduxQuerystring };
      if (!queryStringParams.modal) {
        endDateRef.current = queryStringParams.end_date;
        startDateRef.current = queryStringParams.start_date;
        payablesRef.current = queryStringParams.has_payable_accounts;
        goodsEntryRef.current = queryStringParams.has_goods_receipt;
        pageRef.current = queryStringParams.page;
        itemsPerPageRef.current = queryStringParams.items_per_page;
        entryStatusRef.current = queryStringParams.launch_status as
          | TInvoiceEntryStatus
          | undefined;

        // Cancel previous request
        if (fetchInvoicesCancelTokenRef.current) {
          fetchInvoicesCancelTokenRef.current.cancel(
            "Operation canceled due to new request."
          );
        }
        // Create new token for this request
        fetchInvoicesCancelTokenRef.current = axios.CancelToken.source();

        dispatch(
          fetchExportedIssuedInvoices({
            cancelToken: (
              fetchInvoicesCancelTokenRef.current as CancelTokenSource
            ).token,
          })
        )
          .unwrap()
          .then((response) => {
            allInvoicesRef.current = response?.results;
          })
          .catch((e) => {
            if (axios.isCancel(e)) {
              // Request was canceled, do nothing
            } else {
              console.log(e);
            }
          });
      }
    },
    [window.location.search, reduxQuerystring]
  );

  const debouncedUpdateAllInvoicesRef = useCallback(
    (_entryStatus?: number | undefined, _endDate?: string | undefined) => {
      const queryStringParams = { ...reduxQuerystring };
      if (!queryStringParams.modal && !isRestoringQuerystring) {
        if (debounceRef.current) clearTimeout(debounceRef.current);
        dispatch(setIsLoadingIssuedInvoices(true));
        debounceRef.current = setTimeout(() => {
          updateAllInvoicesRef(_entryStatus, _endDate);
        }, 500);
      }

      if (isRestoringQuerystring) {
        dispatch(setIsRestoringQuerystring(false));
      }
    },
    [updateAllInvoicesRef]
  );

  useEffect(() => {
    debouncedUpdateAllInvoicesRef();
  }, [debouncedUpdateAllInvoicesRef]);

  useEffect(() => {
    if (window.location.pathname === "/") {
      goTo(ROUTES.INVOICES, reduxQuerystring);
    }
  }, [window.location.pathname]);

  return (
    <Container>
      <SummarySection>
        <div>
          <div>
            <BreadCrumbs
              names={["Notas emitidas", "Exportações"]}
              urls={[ROUTES.INVOICES_ISSUED, ROUTES.EXPORT_ISSUED]}
            />
            <h1>Exportações de notas emitidas</h1>
          </div>
          {/* {invoicesUpdatedAt.responseStatus !== 204 &&
            invoicesUpdatedAt.date.length > 0 && (
              <p>
                Atualizado em {format(invoicesUpdatedAt.date, "dd/MM/yyyy")} -{" "}
                {format(invoicesUpdatedAt.date, "HH:mm")}
              </p>
            )} */}
        </div>
        <div className="buttons-container">
          {/* <Button
            icon="plus"
            iconPosition="left"
            variant="outline"
            text="Importar"
            onClick={() => {
              if (filesInputRef.current) filesInputRef.current.click();
            }}
          /> */}
          <div></div>
          <Button
            icon="plus"
            iconPosition="left"
            variant="primary"
            style={{ padding: "12px 16px" }}
            text="Exportar XMLs"
            onClick={() => {
              payableModalInvoiceRef.current = undefined;
              setShouldOpenExportIssuedModal(true);
            }}
          />
        </div>
      </SummarySection>
      <SearchBarSection>
        <SearchBar
          key={reduxQuerystring.invoices_search}
          onClear={() => {
            searchRef.current = undefined;
            const queryStrings = { ...reduxQuerystring };

            delete queryStrings.invoices_search;

            if (entryStatusRef.current) {
              queryStrings.launch_status = entryStatusRef.current ?? 40;
            }

            setQuerystring(queryStrings);

            dispatch(
              fetchExportedIssuedInvoices({
                cancelToken: (
                  fetchInvoicesCancelTokenRef.current as CancelTokenSource
                ).token,
              })
            );
          }}
          $ref={(ref, setSearchString) => {
            if (reduxQuerystring.invoices_search && ref.current) {
              const search = decodeURIComponent(
                reduxQuerystring.invoices_search
              ).replace(/\+/g, " ");
              ref.current.value = search;
              setSearchString(search);
            }
          }}
          onSearch={(searchPhrase) => {
            searchRef.current = searchPhrase;

            if (selectedOrganization) {
              const queryStrings = { ...reduxQuerystring };

              if (searchRef.current.length > 0) {
                queryStrings.invoices_search = searchRef.current;
              } else {
                delete queryStrings.invoices_search;
              }

              if (entryStatusRef.current) {
                queryStrings.launch_status = entryStatusRef.current ?? 40;
              }

              if (queryStrings.page) {
                queryStrings.page = 1;
              }

              if (queryStrings.modal) {
                delete queryStrings.modal;
              }

              setQuerystring(queryStrings);

              // Cancel previous request before dispatching a new one
              if (fetchInvoicesCancelTokenRef.current) {
                fetchInvoicesCancelTokenRef.current.cancel(
                  "Operation canceled due to new request."
                );
              }
              fetchInvoicesCancelTokenRef.current = axios.CancelToken.source();

              dispatch(
                fetchExportedIssuedInvoices({
                  cancelToken: fetchInvoicesCancelTokenRef.current.token,
                })
              );
            }
          }}
          variant="default"
          placeholder="Buscar exportação"
        />
        <SearchBarSectionSubcontainer id={searchBarContainerId}>
          <DropdownFilter
            buttonVariant="checkCircle"
            placeholder="Status"
            content={filteredInvoiceStatusOptions}
            menuVariant="unlabeled"
            search={{
              placeholder: "pesquisar",
              onChange: (searchPhrase) => {
                setEntryStatusSearch(searchPhrase);
              },
              onClear() {
                setEntryStatusSearch("");
              },
            }}
            customFilter={handleEntryStatusCustomFilter}
            onAction={handleEntryStatusOnAction}
            onCancel={handleEntryStatusOnCancel}
            hasBottomBar
            forceSelectOptionsByIndex={(() => {
              const result = handleEntryStatusForceSelectOptions();
              return shouldRejectFilledEntryStatus
                ? undefined
                : result
                ? result.map(Number)
                : undefined;
            })()}
            filled={(() => {
              const result = handleEntryStatusForceSelectOptions();
              return result === undefined
                ? result
                : [...result.toString().replaceAll(",", "")];
            })()}
          />
        </SearchBarSectionSubcontainer>
      </SearchBarSection>

      {invoiceState && (
        <TableGrid
          key={shouldUpdateComponent + "-invoices-tablegrid"}
          row="singleRow"
          columns={{
            tableHead: {
              // 22px 77px 160px 342px 356px 185px 346px 400px 400px 0px
              width: [gridTemplateColumns],
            },
            tableBody: {
              width: [gridTemplateColumns],
            },
          }}
          onAction={() => {
            //
          }}
          emptyState={{
            isEmptyState: !isLoading && invoiceState?.results.length === 0,
            title: "Nenhuma nota encontrada",
            description: "Altere os filtros e realize a busca novamente",
          }}
          customMarginTop="27px"
          selectType={{ type: "noSelect" }}
          tableHead={{
            customPaddingTop: "0px",
            value: [
              { style: "noIcon", showSkeleton: isLoading, value: "ID" },
              {
                style: "noIcon",
                showSkeleton: isLoading,
                value: "Período selecionado",
              },
              {
                style: "noIcon",
                showSkeleton: isLoading,
                value: "Criada em",
              },
              { style: "noIcon", showSkeleton: isLoading, value: "Status" },
            ],
          }}
          isLoading={isLoading}
          tableBody={
            isLoading
              ? new Array(4).fill("").map(() => ({
                  elementId: "",
                  file_nfe: null,
                  file_xml: null,
                  body: [
                    {
                      style: "default",
                      value: "",
                      skeleton: { values: [{ width: "85px" }] },
                    },
                    {
                      style: "default",
                      value: "",
                      skeleton: { values: [{ width: "280px" }] },
                    },
                    {
                      style: "default",
                      value: "",
                      skeleton: { values: [{ width: "340px" }] },
                    },
                    {
                      style: "default",
                      value: "",
                      skeleton: {
                        values: [
                          {
                            width: "210px",
                            style: { maxWidth: "210px", overflow: "hidden" },
                          },
                        ],
                      },
                    },
                    {
                      style: "default",
                      value: "",
                      skeleton: {
                        containerCss: {
                          display: "flex",
                          width: "72px",
                          gap: "4px",
                        },
                        values: [
                          {
                            width: "32px",
                            height: "32px",
                            variant: "square",
                          },
                          {
                            width: "32px",
                            height: "32px",
                            variant: "square",
                          },
                        ],
                      },
                    },
                  ] as TTableBody<TCellStyleVariants>[],
                }))
              : (invoiceState?.results ?? []).map(
                  (invoice: TIssuedInvoicesExport, index: number) => ({
                    elementId: invoice.uuid,
                    file_nfe: invoice.pdf_url,
                    file_xml: invoice.xml_url,
                    body: rowFormatter(invoice, index),
                  })
                )
          }
          footer={{
            customStyle: {
              width: `calc(100vw - 48px - ${sidebarOffset}px)`,
            },
            leftSideDescription:
              " | Total de " +
              invoiceState.count +
              (invoiceState.count > 1
                ? " registros encontrados"
                : " registro encontrado"),
            onSelectItemsPerPage(amount) {
              const querystring = { ...reduxQuerystring };

              if (querystring.page) {
                pageRef.current = querystring.page;
              }

              if (pageRef.current) querystring.page = pageRef.current;

              querystring.items_per_page = amount;

              setQuerystring(querystring);

              dispatch(
                fetchExportedIssuedInvoices({
                  cancelToken: fetchInvoicesCancelTokenRef.current.token,
                })
              );
            },
            customPagination: invoiceState
              ? {
                  fixedBottom: {
                    isFixedAtTheBottom: true,
                    customBottomPosition: "0px",
                  },
                  currentPage: `${invoiceState?.current_page}`,
                  buttonBackward: {
                    disabled: invoiceState.current_page === 1,
                    onClick() {
                      pageRef.current = invoiceState.current_page - 1;

                      const queryStrings = { ...reduxQuerystring };

                      if (queryStrings.items_per_page) {
                        itemsPerPageRef.current = queryStrings.items_per_page;
                      }

                      if (invoiceState.current_page !== 1) {
                        if (pageRef.current)
                          queryStrings.page = pageRef.current;

                        setQuerystring(queryStrings);

                        dispatch(
                          fetchExportedIssuedInvoices({
                            cancelToken:
                              fetchInvoicesCancelTokenRef.current.token,
                          })
                        );
                      }
                    },
                  },
                  buttonForward: {
                    disabled:
                      invoiceState.current_page === invoiceState.pages.length,
                    onClick() {
                      if (
                        invoiceState.current_page === invoiceState.pages.length
                      ) {
                        pageRef.current = invoiceState.current_page;
                      } else {
                        pageRef.current = invoiceState.current_page + 1;
                      }

                      const queryStrings = { ...reduxQuerystring };

                      if (queryStrings.items_per_page) {
                        itemsPerPageRef.current = queryStrings.items_per_page;
                      }

                      if (
                        invoiceState.current_page !== invoiceState.pages.length
                      ) {
                        if (pageRef.current)
                          queryStrings.page = pageRef.current;
                        setQuerystring(queryStrings);

                        dispatch(
                          fetchExportedIssuedInvoices({
                            cancelToken:
                              fetchInvoicesCancelTokenRef.current.token,
                          })
                        );
                      }
                    },
                  },
                  pages: invoiceState.pages.map((page) => {
                    return {
                      value: Object.keys(page)[0],
                      onClick() {
                        let temp =
                          Object.values(page)[0].match(/.*?page=(\d+)&per_/);

                        if (temp !== null && temp[1]) {
                          pageRef.current = parseInt(temp[1]);
                        } else {
                          pageRef.current = 1;
                        }

                        const queryStrings = { ...reduxQuerystring };
                        if (queryStrings.items_per_page) {
                          itemsPerPageRef.current = queryStrings.items_per_page;
                        }

                        if (pageRef.current)
                          queryStrings.page = pageRef.current;
                        setQuerystring(queryStrings);

                        dispatch(
                          fetchExportedIssuedInvoices({
                            cancelToken:
                              fetchInvoicesCancelTokenRef.current.token,
                          })
                        );
                      },
                    };
                  }),
                }
              : undefined,
          }}
        />
      )}
      {shouldOpenExportIssuedModal && (
        <Modal
          key={shouldOpenExportIssuedModal + "-payableModal"}
          shouldOpen={shouldOpenExportIssuedModal}
          icon={{ type: "export", color: "rose" }}
          title="Exportar XMLs de notas emitidas"
          onClose={() => {
            setShouldOpenExportIssuedModal(false);
          }}
          main={{
            style: "form",
            content: {
              preset: "exportIssuedInvoice",
              invoice: payableModalInvoiceRef.current as TIssuedExportedInvoice,
              onChange: (values) => {
                exportFormRef.current = values;
              },
              footer: {
                buttons: [
                  {
                    icon: "noIcon",
                    text: "Fechar",
                    variant: "secondary",
                    onClick() {
                      setShouldOpenExportIssuedModal(false);
                    },
                  },
                  {
                    iconPosition: "left",
                    icon: "checkmark",
                    text: "Criar exportação",
                    variant: "primary",
                    onClick() {
                      handleCreateExport();
                    },
                  },
                ],
              },
            },
          }}
        />
      )}
    </Container>
  );
}

export default IssuedInvoicesExport;
